import { render } from "./PosItem.vue?vue&type=template&id=09c5a5aa&scoped=true"
import script from "./PosItem.vue?vue&type=script&lang=js"
export * from "./PosItem.vue?vue&type=script&lang=js"

import "./PosItem.vue?vue&type=style&index=0&id=09c5a5aa&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c5a5aa"]])

export default __exports__